import qualityHtml from './index.html'
import qualityModal from './quality-modal.html'
import './index.scss'
// import { parseDom, cookieSet } from 'utils'
import { parseDom } from 'src/frontend-lib/tools/domUtil'

const cookieSet = function(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + escape(cvalue) + '; ' + expires
}

const toggleElement = function(element) {
  const visible = element.style.display && element.style.display !== 'none'
  if (visible) {
    element.style.display = 'none'
  } else {
    element.style.display = 'block'
  }
}

/**
 * 切换清晰度组件
 */
export default class QualityComponent {
  constructor(getQuality) {
    this.html = parseDom(qualityHtml)
    this.modalHtml = parseDom(qualityModal)
    this.hasCreated = false
    this.definition = ''
    this.getQuality = getQuality
    this.lastPlayTime = 0
    this.changeQuality = false
    this.hasInitLists = false
    this.changeTimeId = null
  }

  createEl(el, player) {
    const lang = player._options && player._options.language
    this.isEn = lang && lang === 'en-us'
    this.html.querySelector('.current-quality').innerText = this.isEn
      ? 'Resolution'
      : '清晰度'
    this.modalHtml.querySelector('.switchimg').innerText = this.isEn
      ? 'Switching to you for'
      : '正在为您切换到'
    this.modalHtml.querySelector('.wait').innerText = this.isEn
      ? 'Please wait...'
      : '请稍后...'
    let eleControlbar = el.querySelector('.prism-controlbar')
    eleControlbar.appendChild(this.html)
    el.appendChild(this.modalHtml)
  }

  setCurrentQuality(quality, def) {
    let currentQuality = this.html.querySelector('.current-quality')
    currentQuality.innerText = quality
    currentQuality.dataset.def = def
    this.definition = def

    let qualityListEle = this.html.querySelector('.quality-list')
    let currentEle = qualityListEle.querySelector('.current')
    if (currentEle) {
      currentEle.className = ''
    }
    let li_target = qualityListEle.querySelector(`li[data-def="${def}"]`)
    if (li_target) {
      li_target.className = 'current'
    }
    qualityListEle.style.display = 'none'
  }

  setCurrentPlayTime(player) {
    if (this.changeQuality) {
      player.seek(this.lastPlayTime)
      this.changeQuality = false
    }
  }

  resetCurrentPlayTime(player) {
    this.lastPlayTime = 0
  }

  created(player) {}

  ready(player) {
    this.modalHtml.style.display = 'none'
    // 隐藏设置里面的清晰度
    let settingEle = document.querySelector(
      '.prism-setting-item.prism-setting-quality'
    )
    if (settingEle) {
      settingEle.classList.add('player-hidden')
    }

    this.initLists(player)
  }

  initLists(player) {
    if (this.hasInitLists) {
      return
    }

    this._urls = player._qualityService.levels
    console.log(
      'aliplayer _qualityService.levels:',
      this._urls,
      this._urls.length
    )

    let currentQualityEle = this.html.querySelector('.current-quality')
    let qualityListEle = this.html.querySelector('.quality-list')

    let lis_ele = this._urls.map(url => {
      let desc = typeof url.desc == 'number' ? url.resolution : url.desc
      return `<li data-def="${desc}">${desc}</li>`
    })
    this.html.querySelector('.quality-list').innerHTML = lis_ele.join('')

    if (this.hasCreated == false && this.definition) {
      let li_target = qualityListEle.querySelector(
        `li[data-def="${this.definition}"]`
      )
      li_target.className = 'current'
    }
    this.hasCreated = true

    let timeId = null

    const hide = () => {
      timeId = window.setTimeout(() => {
        qualityListEle.style.display = 'none'
      }, 100)
    }

    currentQualityEle.onclick = () => {
      toggleElement(qualityListEle)
    }

    currentQualityEle.onmouseleave = () => {
      hide()
    }

    qualityListEle.onmouseenter = () => {
      clearTimeout(timeId)
    }
    qualityListEle.onmouseleave = () => {
      hide()
    }

    qualityListEle.onclick = ({ target }) => {
      let definition = target.dataset.def
      let desc = target.innerText
      if (definition && target.className !== 'current') {
        let url = this._urls.find(url => {
          let desc = typeof url.desc == 'number' ? url.resolution : url.desc
          let r = String(desc) === definition
          return r
        })
        console.log('=== qualityListEle.onclick === url:', url)
        if (url) {
          this.lastPlayTime = Math.floor(player.getCurrentTime())
          this.changeQuality = true
          cookieSet('selectedStreamLevel', url.definition, 365)
          if (player._switchLevel && !player._options.isLive) {
            player._switchLevel(url.Url)
          } else {
            player._loadByUrlInner(
              url.Url,
              player.getCurrentTime(),
              true /*autoPlay*/,
              true /* isSwitchLevel */
            )
          }

          let desc = typeof url.desc == 'number' ? url.resolution : url.desc
          this.setCurrentQuality(desc, desc)
          this.modalHtml.style.display = 'block'
          this.modalHtml.querySelector(
            'span.current-quality-tag'
          ).innerText = desc
          clearTimeout(this.changeTimeId)
          this.changeTimeId = window.setTimeout(() => {
            this.modalHtml.style.display = 'none'
          }, 1500)
        }
      }
      //点击切换清晰度时，调用这个方法
      this.getQuality(definition, desc)
    }

    player.on('touchstart', () => {
      clearTimeout(timeId)
    })
    player.on('touchend', ({ target }) => {
      if (target === qualityListEle || target === currentQualityEle) {
        return
      }
      hide()
    })

    this.hasInitLists = true
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/QualityComponent/index.js